import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './styles.css';
import { installLayoutGuard } from './layout-guard.js';

createRoot(document.getElementById('app')).render(<App />);

// So em desenvolvimento: avisa no console se alguma tela passar da largura.
installLayoutGuard();
